import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

import PageSpinner from 'components/PageSpinner';

import { RequireAPI } from 'apps/core/api_status/store';
import { ErrorBoundary, SiteOptions } from 'apps/core/site_options/store';
import { lazy } from 'utils/hooks';

import store from 'store';

const PortalApps = lazy(() => import('./PortalApps.jsx'));
const CEIOApps = lazy(() => import('./CEIOApps.tsx'));

// styled-components v6 stopped filtering non-standard props off of DOM
// elements by default. This restores v5's behavior globally so components
// written against the old automatic filtering don't leak custom props
// (e.g. `active`, `size`) onto the rendered DOM node.
const shouldForwardProp = (propName, target) => (
    typeof target === 'string' ? isPropValid(propName) : true
);

const App = () => (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <Provider store={store}>
            <RequireAPI>
                <ErrorBoundary>
                    <SiteOptions>
                        {({ brand, role, loggedIn }) => {
                            if (brand.slug === 'ceio') {
                                return (
                                    <Suspense fallback={<PageSpinner />}>
                                        <CEIOApps />
                                    </Suspense>
                                );
                            } else if (brand.slug === 'hellocgi') {
                                return (
                                    <Suspense fallback={<PageSpinner />}>
                                        <PortalApps brand={brand} role={role} loggedIn={loggedIn} />
                                    </Suspense>
                                );
                            } else if (role) {
                                return <p>Site could not be identified.</p>;
                            } else {
                                return null;
                            }
                        }}
                    </SiteOptions>
                </ErrorBoundary>
            </RequireAPI>
        </Provider>
    </StyleSheetManager>
);

export default App;
